import HomeHero from './components/HomeHero';
import { Statement, Philosophy, Services, Moments, Spaces, VisitCta } from './components/HomeSections';

// Image reveals are initialised globally in SiteLayout. The Hero is not tagged.
export default function Home() {
  return (
    <>
      <HomeHero />
      <Statement />
      <Philosophy />
      <Services />
      <Moments />
      <Spaces />
      <VisitCta />
    </>
  );
}